/* assets/littleg-opening-gate.js — LITTLEG-HOME-GATEWAY-RUNTIME-35
 *
 * Homepage interaction/controller owner.
 *
 * OWNS
 * - Hero rotation
 * - Hero pause/resume lifecycle
 * - Enquiry dialog interaction
 * - Shopify section load/unload lifecycle
 * - Micro-interactions (Parallax & Magnetic Button)
 *
 * DOES NOT OWN
 * - Search
 * - Place resolution
 * - Navigation routing
 * - Spatial/WebGL rendering
 * - Homepage DOM creation
 * - Visual layout
 */
(function littlegHomeGatewayRuntime(window, document) {
  'use strict';

  var VERSION = 'LITTLEG-HOME-GATEWAY-RUNTIME-35';
  var RUNTIME_KEY = '__LITTLEG_HOME_GATEWAY_RUNTIME__';
  var ROOT_SELECTOR = '[data-littleg-opening-gate]';

  if (
    window[RUNTIME_KEY] &&
    window[RUNTIME_KEY].version === VERSION
  ) {
    return;
  }

  var controllers = new WeakMap();
  var motionPreference = null;

  try {
    motionPreference = window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    );
  } catch (_) {
    motionPreference = null;
  }

  function reducedMotion() {
    return Boolean(
      motionPreference &&
      motionPreference.matches
    );
  }

  function toArray(value) {
    return Array.prototype.slice.call(value || []);
  }

  function listen(
    disposers,
    target,
    type,
    handler,
    options
  ) {
    if (!target || !target.addEventListener) return;

    target.addEventListener(
      type,
      handler,
      options
    );

    disposers.push(function () {
      target.removeEventListener(
        type,
        handler,
        options
      );
    });
  }
  


 function rootsIn(scope) {
    if (!scope) return [];

    var roots = [];

    if (
      scope.matches &&
      scope.matches(ROOT_SELECTOR)
    ) {
      roots.push(scope);
    }

    if (scope.querySelectorAll) {
      roots = roots.concat(
        toArray(
          scope.querySelectorAll(ROOT_SELECTOR)
        )
      );
    }

    return roots;
  }

function mountHeroRotator(root, disposers) {
    var rotator = root.querySelector(
      '[data-opening-hero-rotator]'
    );

    var line1 = root.querySelector(
      '[data-opening-hero-line-1]'
    );

    var line2 = root.querySelector(
      '[data-opening-hero-line-2]'
    );

    var lead = root.querySelector(
      '[data-opening-hero-lead]'
    );

    var dots = toArray(
      root.querySelectorAll(
        '[data-opening-hero-dot]'
      )
    );

    if (
      !rotator ||
      !line1 ||
      !line2 ||
      !lead ||
      dots.length < 2
    ) {
      return;
    }

    var slides = dots.map(function (dot) {
      return {
        line1: dot.getAttribute('data-hero-line-1') || '',
        line2: dot.getAttribute('data-hero-line-2') || '',
        lead: dot.getAttribute('data-hero-lead') || ''
      };
    });

    if (
      slides.some(function (slide) {
        return !slide.line1 || !slide.line2;
      })
    ) {
      return;
    }

    var index = Number(
      rotator.getAttribute(
        'data-hero-index'
      )
    );

    if (!Number.isFinite(index)) {
      index = 0;
    }

    index =
      (index + slides.length) %
      slides.length;

    var timer = 0;
    var transitionTimer = 0;
    var visible = true;
    var observer = null;

    function clearTransition() {
      if (!transitionTimer) return;

      window.clearTimeout(
        transitionTimer
      );

      transitionTimer = 0;

      rotator.removeAttribute(
        'data-hero-transitioning'
      );
    }

    function updateDots() {
      dots.forEach(function (dot, dotIndex) {
        var active = dotIndex === index;

        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    }

function applySlide() {
      var slide = slides[index];

      line1.textContent = slide.line1;
      line2.textContent = slide.line2;
      lead.textContent = slide.lead;

      rotator.setAttribute(
        'data-hero-index',
        String(index)
      );

      updateDots();
    }


   function render(nextIndex, animate) {
      index =
        (nextIndex + slides.length) %
        slides.length;

      clearTransition();

      if (animate === false || reducedMotion()) {
        applySlide();
        return;
      }

      rotator.setAttribute(
        'data-hero-transitioning',
        'true'
      );

      transitionTimer =
        window.setTimeout(function () {
          transitionTimer = 0;
          applySlide();

          window.requestAnimationFrame(
            function () {
              rotator.removeAttribute(
                'data-hero-transitioning'
              );
            }
          );
        }, 850);
    }

    function stop() {
      if (!timer) return;

      window.clearInterval(timer);
      timer = 0;
    }

   function start() {
      stop();

      if (
        reducedMotion() ||
        document.hidden ||
        !visible
      ) {
        return;
      }

      timer = window.setInterval(
        function () {
          render(index + 1, true);
        },
        5200
      );
    }

    dots.forEach(function (dot) {
      listen(
        disposers,
        dot,
        'click',
        function () {
          var nextIndex = Number(
            dot.getAttribute(
              'data-opening-hero-dot'
            )
          );

          if (!Number.isFinite(nextIndex)) {
            return;
          }

          render(nextIndex, true);
          start();
        }
      );
    });

    listen(disposers, rotator, 'mouseenter', stop);
    listen(disposers, rotator, 'mouseleave', start);
    listen(disposers, rotator, 'focusin', stop);
    listen(
      disposers,
      rotator,
      'focusout',
      function (event) {
        if (
          event.relatedTarget &&
          rotator.contains(
            event.relatedTarget
          )
        ) {
          return;
        }

        start();
      }
    );

    listen(disposers, document, 'visibilitychange', start);

    if (motionPreference) {
      var onMotionChange = function () {
        if (reducedMotion()) {
          stop();
          clearTransition();
          applySlide();
        } else {
          start();
        }
      };

      if (typeof motionPreference.addEventListener === 'function') {
        motionPreference.addEventListener('change', onMotionChange);
        disposers.push(function () {
          motionPreference.removeEventListener('change', onMotionChange);
        });
      } else if (typeof motionPreference.addListener === 'function') {
        motionPreference.addListener(onMotionChange);
        disposers.push(function () {
          motionPreference.removeListener(onMotionChange);
        });
      }
    }

    if (window.IntersectionObserver) {
      observer =
        new IntersectionObserver(
          function (entries) {
            visible = Boolean(
              entries[0] &&
              entries[0].isIntersecting
            );

            if (visible) {
              start();
            } else {
              stop();
            }
          },
          {
            threshold: 0.05
          }
        );

      observer.observe(rotator);

      disposers.push(function () {
        observer.disconnect();
      });
    }

    applySlide();
    start();

    disposers.push(function () {
      stop();
      clearTransition();
      rotator.removeAttribute('data-hero-transitioning');
    });
  }


  function mountEnquiryDialog(root, disposers) {
    var trigger = root.querySelector('[data-glg-enquiry-open]');
    var dialog = root.querySelector('[data-glg-enquiry-dialog]');
    var closeButton = dialog && dialog.querySelector('[data-glg-enquiry-close]');

    if (!trigger || !dialog || !closeButton) {
      return;
    }

    function openDialog() {
      if (dialog.open || typeof dialog.showModal !== 'function') return;
      dialog.showModal();
    }

    function closeDialog() {
      if (!dialog.open || typeof dialog.close !== 'function') return;
      dialog.close();
    }

    listen(disposers, trigger, 'click', openDialog);
    listen(disposers, closeButton, 'click', closeDialog);

    listen(disposers, dialog, 'close', function () {
      if (trigger.isConnected && typeof trigger.focus === 'function') {
        trigger.focus();
      }
    });

    listen(disposers, dialog, 'click', function (event) {
      if (event.target !== dialog) return;

      var rect = dialog.getBoundingClientRect();
      var outside =
        event.clientX < rect.left ||
        event.clientX > rect.right ||
        event.clientY < rect.top ||
        event.clientY > rect.bottom;

      if (outside) {
        closeDialog();
      }
    });

    var result = dialog.querySelector(
      '.glg-asia-home__success, .glg-asia-home__errors'
    );

    if (result) {
      openDialog();
      window.requestAnimationFrame(function () {
        if (typeof result.focus === 'function') {
          result.focus();
        }
      });
    }
  }
function mountAurora(root, disposers) {
    const light = root.querySelector('.littleg-opening-gate__aurora-light');
    const toggle = root.querySelector('[data-opening-aurora-toggle]');
    if (!light) return;

    const eligible = window.matchMedia(
      'screen and (min-width: 1024px) and ' +
      '(prefers-reduced-motion: no-preference) and ' +
      '(forced-colors: none)'
    );

    let manualPaused = false;
    let inView = true;

    function syncAurora() {
      const canAnimate = eligible.matches;
      const shouldRun =
        canAnimate &&
        !manualPaused &&
        !document.hidden &&
        inView;

      light.style.setProperty(
        '--opening-aurora-play-state',
        shouldRun ? 'running' : 'paused'
      );

      if (toggle) {
        toggle.hidden = !canAnimate;
        toggle.setAttribute('aria-pressed', String(manualPaused));
      }
    }

   function toggleAurora() {
      manualPaused = !manualPaused;
      syncAurora();
    }

    const observer = window.IntersectionObserver
      ? new IntersectionObserver(function (entries) {
          inView = entries.some(function (entry) {
            return entry.isIntersecting;
          });
          syncAurora();
        })
      : null;

    if (observer) {
      inView = false;
      observer.observe(root);
    }

    if (toggle) toggle.addEventListener('click', toggleAurora);
    document.addEventListener('visibilitychange', syncAurora);

    if (typeof eligible.addEventListener === 'function') {
      eligible.addEventListener('change', syncAurora);
    } else {
      eligible.addListener(syncAurora);
    }

    disposers.push(function () {
      if (observer) observer.disconnect();

      light.style.removeProperty('--opening-aurora-play-state');
      if (toggle) {
        toggle.hidden = true;
        toggle.setAttribute('aria-pressed', 'false');
      }

      if (toggle) toggle.removeEventListener('click', toggleAurora);
      document.removeEventListener('visibilitychange', syncAurora);

      if (typeof eligible.removeEventListener === 'function') {
        eligible.removeEventListener('change', syncAurora);
      } else {
        eligible.removeListener(syncAurora);
      }
    });

    syncAurora();
  }

  function mountMicroInteractions(root, disposers) {
    var eligibility = window.matchMedia('screen and (hover: hover) and (pointer: fine) and (prefers-reduced-motion: no-preference) and (forced-colors: none)');
    var building = root.querySelector('[data-opening-hero-building]');
    var primary = root.querySelector('[data-opening-hero-primary-btn]');

    function track(node, names) {
      if (!node) return null;
      return {
        node: node,
        properties: names.map(function (name) {
          return { name: name, value: node.style.getPropertyValue(name), priority: node.style.getPropertyPriority(name) };
        })
      };
    }

    var buildingStyles = track(building, ['--opening-parallax-x', '--opening-parallax-y']);
    var primaryStyles = track(primary, ['--opening-magnet-x', '--opening-magnet-y']);

    function restore(record) {
      if (!record) return;
      record.properties.forEach(function (property) {
        if (property.value) record.node.style.setProperty(property.name, property.value, property.priority);
        else record.node.style.removeProperty(property.name);
      });
    }

    function canMove(event) {
      return eligibility.matches && !document.hidden &&
        (!event.pointerType || event.pointerType === 'mouse') &&
        !(event.target.closest && event.target.closest('input, textarea, select, [contenteditable], dialog, [data-native-cursor]'));
    }

    function reset() {
      restore(buildingStyles);
      restore(primaryStyles);
    }

    if (building) {
      listen(disposers, root, 'pointermove', function (event) {
        if (!canMove(event)) return;
        var rect = root.getBoundingClientRect();
        if (!rect.width || !rect.height) return;
        var x = Math.max(-.5, Math.min(.5, (event.clientX - rect.left) / rect.width - .5));
        var y = Math.max(-.5, Math.min(.5, (event.clientY - rect.top) / rect.height - .5));
        building.style.setProperty('--opening-parallax-x', (x * 12).toFixed(2) + 'px');
        building.style.setProperty('--opening-parallax-y', (y * 12).toFixed(2) + 'px');
      }, { passive: true });
      listen(disposers, root, 'pointerleave', function () { restore(buildingStyles); });
    }

    if (primary) {
      listen(disposers, primary, 'pointermove', function (event) {
        if (!canMove(event)) return;
        var rect = primary.getBoundingClientRect();
        var x = Math.max(-3, Math.min(3, (event.clientX - rect.left - rect.width / 2) * .1));
        var y = Math.max(-3, Math.min(3, (event.clientY - rect.top - rect.height / 2) * .1));
        primary.style.setProperty('--opening-magnet-x', x.toFixed(2) + 'px');
        primary.style.setProperty('--opening-magnet-y', y.toFixed(2) + 'px');
      }, { passive: true });
      listen(disposers, primary, 'pointerleave', function () { restore(primaryStyles); });
      listen(disposers, primary, 'focusin', function () { restore(primaryStyles); });
    }

    listen(disposers, window, 'blur', reset);
    listen(disposers, window, 'beforeprint', reset);
    listen(disposers, document, 'visibilitychange', function () { if (document.hidden) reset(); });
    if (eligibility.addEventListener) listen(disposers, eligibility, 'change', reset);
    else {
      eligibility.addListener(reset);
      disposers.push(function () { eligibility.removeListener(reset); });
    }
    disposers.push(reset);
  }

  function mountPosterMotion(root, disposers) {
    const poster = root.querySelector('.opening-company-media__poster');

    if (!poster || !window.IntersectionObserver) return;

    const eligibility = window.matchMedia(
      '(min-width: 1025px) and (hover: hover) and (pointer: fine) and ' +
      '(prefers-reduced-motion: no-preference) and (forced-colors: none)'
    );

    let inView = false;
    let destroyed = false;
    let windowFocused = document.hasFocus();

    const stop = () => {
      poster.removeAttribute('data-opening-poster-motion');
    };

    const isDisplayed = (node) => {
      if (!node || !node.isConnected) return false;

      const style = window.getComputedStyle(node);
      const bounds = node.getBoundingClientRect();

      return style.display !== 'none' &&
        style.visibility === 'visible' &&
        Number(style.opacity) > 0 &&
        bounds.width > 0 &&
        bounds.height > 0;
    };

    const sync = () => {
      if (
        destroyed ||
        document.hidden ||
        !windowFocused ||
        !eligibility.matches ||
        !inView ||
        !poster.complete ||
        poster.naturalWidth === 0 ||
        !isDisplayed(poster)
      ) {
        stop();
        return;
      }

      if (root.dataset.openingMediaState !== 'poster') {
        stop();
        return;
      }

      poster.setAttribute('data-opening-poster-motion', '');
    };

    const observer = new IntersectionObserver((entries) => {
      inView = entries.some((entry) => entry.isIntersecting);
      sync();
    });

    observer.observe(poster);

    listen(disposers, poster, 'load', sync);
    listen(disposers, poster, 'error', stop);

    listen(disposers, window, 'blur', () => {
      windowFocused = false;
      stop();
    });

    listen(disposers, window, 'focus', () => {
      windowFocused = true;
      sync();
    });

    listen(disposers, document, 'visibilitychange', () => {
      windowFocused = document.hasFocus();
      sync();
    });

    listen(disposers, window, 'resize', sync, { passive: true });

    if (eligibility.addEventListener) {
      listen(disposers, eligibility, 'change', sync);
    } else {
      eligibility.addListener(sync);
      disposers.push(() => eligibility.removeListener(sync));
    }

    listen(disposers, root, 'opening:media-state', sync);

    disposers.push(() => {
      destroyed = true;
      observer.disconnect();
      stop();
    });

    sync();
  }

  function mountOpticalEffects(root, disposers) {
    if (root.dataset.motionBound === 'true') return;
    root.dataset.motionBound = 'true';

    disposers.push(() => {
      delete root.dataset.motionBound;
    });

    var eligibility = window.matchMedia('screen and (hover: hover) and (pointer: fine) and (prefers-reduced-motion: no-preference) and (forced-colors: none)');
    var dock = root.querySelector('#glg-asia-services');
    var building = root.querySelector('[data-opening-hero-building]');
    var displacement = root.querySelector('[data-opening-displacement]');
    var turbulence = root.querySelector('[data-opening-turbulence]');
    var filter = displacement && displacement.closest('filter');
    var dot = root.querySelector('[data-opening-cursor-dot]');
    var halo = root.querySelector('[data-opening-cursor-halo]');
    var rippleProperty = '--opening-building-ripple';
    var originalRipple = building ? building.style.getPropertyValue(rippleProperty) : '';
    var ripplePriority = building ? building.style.getPropertyPriority(rippleProperty) : '';

    function restoreRipple() {
      if (!building) return;
      if (originalRipple) building.style.setProperty(rippleProperty, originalRipple, ripplePriority);
      else building.style.removeProperty(rippleProperty);
    }
    var enabled = false;
    var active = false;
    var frame = 0;
    var previousTime = 0;
    var pointer = null;
    var previousPointer = null;
    var haloX = 0;
    var haloY = 0;
    var spotlight = null;
    let spotlightBounds = null;
    var impulse = 0;
    var scale = 0;

    function clearSpotlight() {
      if (spotlight) {
        spotlight.removeAttribute('data-opening-tilt-active');
        spotlight.style.setProperty('--spotlight-active', '0');
        [
          '--mouse-x',
          '--mouse-y',
          '--tilt-rx',
          '--tilt-ry',
          '--tilt-scale'
        ].forEach((name) => {
          spotlight.style.removeProperty(name);
        });
      }
      spotlight = null;
      spotlightBounds = null;
    }

    function hideCursor() {
      active = false;
      root.removeAttribute('data-opening-cursor-active');
      root.removeAttribute('data-opening-cursor-link');
    }

    function reset() {
      if (frame) window.cancelAnimationFrame(frame);
      frame = 0;
      previousTime = 0;
      pointer = previousPointer = null;
      impulse = scale = 0;
      hideCursor();
      clearSpotlight();
      if (displacement) displacement.setAttribute('scale', '0');
      restoreRipple();
    }

    function requestFrame() {
      if (!frame && enabled) frame = window.requestAnimationFrame(draw);
    }

    function draw(time) {
      frame = 0;
      if (!enabled || document.hidden) { reset(); return; }
      var elapsed = previousTime ? Math.min(40, time - previousTime) : 16;
      previousTime = time;
      var blend = 1 - Math.exp(-elapsed / 75);
      var unsettled = false;

      if (active && pointer) {
        var clickable = pointer.target.closest('a, button, [role="button"]');
        var haloTargetX = pointer.x;
        var haloTargetY = pointer.y;
        if (clickable) {
          var targetBounds = clickable.getBoundingClientRect();
          haloTargetX += Math.max(-8, Math.min(8, (targetBounds.left + targetBounds.width / 2 - pointer.x) * .12));
          haloTargetY += Math.max(-8, Math.min(8, (targetBounds.top + targetBounds.height / 2 - pointer.y) * .12));
        }
        haloX += (haloTargetX - haloX) * blend;
        haloY += (haloTargetY - haloY) * blend;
        if (dot && halo) {
          dot.style.transform = 'translate3d(' + pointer.x + 'px,' + pointer.y + 'px,0)';
          halo.style.transform = 'translate3d(' + haloX + 'px,' + haloY + 'px,0)';
          root.setAttribute('data-opening-cursor-active', '');
          root.toggleAttribute('data-opening-cursor-link', Boolean(clickable));
        }
        unsettled = Math.abs(haloTargetX - haloX) + Math.abs(haloTargetY - haloY) > .1;
      }

      if (pointer && pointer !== previousPointer) {
        const cardSelector = '.littleg-opening-gate__orbit-node, .lg-icon-apps__item, .opening-product-card';
        let card = dock && pointer.target.closest(cardSelector);
        if (card && !dock.contains(card)) card = null;
        if (card !== spotlight) {
          clearSpotlight();
          spotlight = card;

          if (spotlight) {
            const bounds = spotlight.getBoundingClientRect();

            spotlightBounds = {
              left: bounds.left,
              top: bounds.top,
              width: bounds.width,
              height: bounds.height
            };
          }
        }

        if (spotlight && spotlightBounds) {
          const cardBounds = spotlightBounds;

          if (cardBounds.width > 0 && cardBounds.height > 0) {
            const x = pointer.x - cardBounds.left;
            const y = pointer.y - cardBounds.top;

            spotlight.setAttribute('data-opening-spotlight', '');
            spotlight.style.setProperty('--mouse-x', x.toFixed(2) + 'px');
            spotlight.style.setProperty('--mouse-y', y.toFixed(2) + 'px');
            spotlight.style.setProperty('--spotlight-active', '1');

            if (spotlight.matches('.opening-product-card')) {
              spotlight.setAttribute('data-opening-tilt-active', '');

              const normalizedX = Math.max(
                -1,
                Math.min(1, x / cardBounds.width * 2 - 1)
              );
              const normalizedY = Math.max(
                -1,
                Math.min(1, y / cardBounds.height * 2 - 1)
              );

              spotlight.style.setProperty(
                '--tilt-rx',
                (-normalizedY * 3).toFixed(2) + 'deg'
              );
              spotlight.style.setProperty(
                '--tilt-ry',
                (normalizedX * 3).toFixed(2) + 'deg'
              );
              spotlight.style.setProperty('--tilt-scale', '1.01');
            }
          } else {
            clearSpotlight();
          }
        }
        if (building && filter && typeof window.SVGFEDisplacementMapElement === 'function') {
          var bounds = building.getBoundingClientRect();
          var inside = bounds.width > 0 && bounds.height > 0 && pointer.x >= bounds.left && pointer.x <= bounds.right && pointer.y >= bounds.top && pointer.y <= bounds.bottom;
          if (inside) {
            var distance = previousPointer ? Math.hypot(pointer.x - previousPointer.x, pointer.y - previousPointer.y) : 0;
            impulse = Math.min(2.5, .4 + distance * .025);
            if (turbulence) turbulence.setAttribute('baseFrequency',
              (.01 + (pointer.x - bounds.left) / bounds.width * .003).toFixed(4) + ' ' +
              (.016 + (pointer.y - bounds.top) / bounds.height * .004).toFixed(4));
          }
        }
        previousPointer = pointer;
      }

      impulse *= Math.exp(-elapsed / 130);
      scale += (impulse - scale) * blend;
      if (displacement && building && filter) {
        if (scale > .02) {
          displacement.setAttribute('scale', scale.toFixed(3));
          building.style.setProperty(rippleProperty, 'url("#' + filter.id + '")');
          unsettled = true;
        } else {
          scale = 0;
          displacement.setAttribute('scale', '0');
          restoreRipple();
        }
      }
      if (unsettled) requestFrame();
      else previousTime = 0;
    }

    function syncEligibility() {
      enabled = eligibility.matches && !document.hidden;
      root.toggleAttribute('data-opening-optics-ready', enabled);
      if (!enabled) reset();
    }

    listen(disposers, document, 'pointerdown', (event) => {
      if (event.pointerType !== 'mouse') reset();
    }, { passive: true });

    listen(disposers, document, 'pointercancel', reset, {
      passive: true
    });

    listen(disposers, document, 'touchend', reset, {
      passive: true
    });

    listen(disposers, document, 'shopify:section:select', (event) => {
      if (
        event.target === root ||
        event.target?.contains?.(root)
      ) {
        reset();
      }
    });

    listen(disposers, root, 'pointermove', function (event) {
      if (event.pointerType !== 'mouse') {
        reset();
        return;
      }
      if (!enabled) return;
      var target = event.target && event.target.closest ? event.target : null;
      if (!target || target.closest('input, textarea, select, [contenteditable], dialog, [data-native-cursor]')) {
        pointer = previousPointer = null;
        hideCursor();
        clearSpotlight();
        return;
      }
      if (!active) { haloX = event.clientX; haloY = event.clientY; }
      pointer = { x: event.clientX, y: event.clientY, target: target };
      active = true;
      requestFrame();
    }, { passive: true });
    listen(disposers, root, 'pointerleave', function () {
      pointer = previousPointer = null;
      hideCursor();
      clearSpotlight();
      requestFrame();
    });
    listen(disposers, window, 'resize', reset, {
      passive: true
    });

    listen(disposers, document, 'scroll', reset, {
      passive: true,
      capture: true
    });

    if (window.ResizeObserver && dock) {
      const layoutObserver = new ResizeObserver(() => {
        reset();
      });

      layoutObserver.observe(dock);

      dock.querySelectorAll('.opening-product-card').forEach((card) => {
        layoutObserver.observe(card);
      });

      disposers.push(() => {
        layoutObserver.disconnect();
      });
    }

    listen(disposers, document, 'keydown', reset);
    listen(disposers, root, 'focusin', reset);
    listen(disposers, root, 'click', function () {
      if (root.querySelector('dialog[open]')) { hideCursor(); clearSpotlight(); }
    });
    listen(disposers, window, 'blur', reset);
    listen(disposers, window, 'beforeprint', reset);
    listen(disposers, document, 'visibilitychange', syncEligibility);
    if (eligibility.addEventListener) listen(disposers, eligibility, 'change', syncEligibility);
    else {
      eligibility.addListener(syncEligibility);
      disposers.push(function () { eligibility.removeListener(syncEligibility); });
    }
    disposers.push(function () {
      enabled = false;
      reset();
      root.removeAttribute('data-opening-optics-ready');
      root.querySelectorAll('[data-opening-spotlight]').forEach(function (card) {
        card.removeAttribute('data-opening-spotlight');
        ['--mouse-x', '--mouse-y', '--spotlight-active'].forEach(function (name) { card.style.removeProperty(name); });
      });
      [dot, halo].forEach(function (node) { if (node) node.style.removeProperty('transform'); });
    });
    syncEligibility();
  }

  function mountTenderCardStats(root, disposers) {
    const target = root.querySelector('[data-opening-tender-stats]');
    if (!target) return;

    const fallback = target.textContent;
    const locale = document.documentElement.lang || 'en';
    const oneTemplate = target.dataset.countOne;
    const otherTemplate = target.dataset.countOther;

    if (
      !oneTemplate?.includes('__COUNT__') ||
      !otherTemplate?.includes('__COUNT__')
    ) {
      return;
    }

    const hongKongDay = () => {
      const parts = new Intl.DateTimeFormat('en', {
        timeZone: 'Asia/Hong_Kong',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      }).formatToParts(new Date());

      const values = Object.fromEntries(
        parts.map(({ type, value }) => [type, value])
      );

      return `${values.year}-${values.month}-${values.day}`;
    };

    const requestedDay = hongKongDay();
    const query = new URLSearchParams({
      published_from: requestedDay,
      published_to: requestedDay
    });

    const controller = new AbortController();
    let destroyed = false;

    const timeout = window.setTimeout(() => {
      controller.abort();
    }, 8000);

    const read = async (path) => {
      const response = await fetch(
        'https://api.glhksolution.com' + path,
        {
          method: 'GET',
          credentials: 'omit',
          headers: { Accept: 'application/json' },
          signal: controller.signal
        }
      );

      if (!response.ok) {
        throw new Error('Tender statistics request failed');
      }

      return response.json();
    };

    disposers.push(() => {
      destroyed = true;
      controller.abort();
      window.clearTimeout(timeout);
      target.textContent = fallback;
    });

    read('/api/tender/search?' + query.toString()).then((search) => {
      if (destroyed) return;

      const total = search.total;

      if (
        search.ok !== true ||
        !Number.isSafeInteger(total) ||
        total < 0 ||
        search.published_from !== requestedDay ||
        search.published_to !== requestedDay ||
        hongKongDay() !== requestedDay
      ) {
        throw new Error('Invalid daily tender statistics');
      }

      const number = new Intl.NumberFormat(locale).format(total);
      const template = total === 1 ? oneTemplate : otherTemplate;

      target.textContent = template
        .split('__COUNT__')
        .join(number);
    }).catch(() => {
      if (!destroyed) {
        target.textContent = fallback;
      }
    }).finally(() => {
      window.clearTimeout(timeout);
    });
  }

  function mount(root) {
    if (!root || controllers.has(root)) {
      return;
    }

    var disposers = [];

    mountAurora(root, disposers);
    mountHeroRotator(root, disposers);
    mountMicroInteractions(root, disposers);

    {
      const cta = root.querySelector('[data-opening-explore]');
      const shimmer = cta?.querySelector('.opening-cta-shimmer');

      if (cta && shimmer) {
        const sweepEligibility = window.matchMedia(
          '(hover: hover) and (pointer: fine) and ' +
          '(prefers-reduced-motion: no-preference) and ' +
          '(forced-colors: none)'
        );

        const resetSweep = () => {
          cta.classList.remove('is-opening-sweeping');
        };

        const startSweep = (event) => {
          if (
            event.pointerType !== 'mouse' ||
            !sweepEligibility.matches ||
            document.hidden ||
            cta.classList.contains('is-opening-sweeping')
          ) {
            return;
          }

          cta.classList.add('is-opening-sweeping');
        };

        listen(disposers, cta, 'pointerenter', startSweep);
        listen(disposers, cta, 'pointerleave', resetSweep);
        listen(disposers, cta, 'pointercancel', resetSweep);

        listen(disposers, shimmer, 'animationend', (event) => {
          if (
            event.target === shimmer &&
            event.animationName === 'opening-cta-single-sweep'
          ) {
            resetSweep();
          }
        });

        listen(disposers, document, 'pointerdown', (event) => {
          if (event.pointerType !== 'mouse') resetSweep();
        }, { passive: true });

        listen(disposers, window, 'blur', resetSweep);

        listen(disposers, document, 'visibilitychange', () => {
          if (document.hidden) resetSweep();
        });

        listen(disposers, document, 'shopify:section:select', (event) => {
          if (
            event.target === root ||
            event.target?.contains?.(root)
          ) {
            resetSweep();
          }
        });

        if (sweepEligibility.addEventListener) {
          listen(disposers, sweepEligibility, 'change', resetSweep);
        } else {
          sweepEligibility.addListener(resetSweep);
          disposers.push(() => {
            sweepEligibility.removeListener(resetSweep);
          });
        }

        disposers.push(resetSweep);
      }
    }

    mountOpticalEffects(root, disposers);
    mountPosterMotion(root, disposers);
    mountTenderCardStats(root, disposers);
    mountEnquiryDialog(root, disposers);

    controllers.set(root, {
      disposers: disposers
    });
  }

 function destroyRoot(root) {
    var controller = controllers.get(root);

    if (!controller) return;

    controller.disposers
      .splice(0)
      .forEach(function (dispose) {
        try {
          dispose();
        } catch (_) {}
      });

    controllers.delete(root);
  }

 function boot(scope) {
    rootsIn(scope || document).forEach(mount);
  }

  function destroy(scope) {
    rootsIn(scope || document).forEach(destroyRoot);
  }

  function initialBoot() {
    boot(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialBoot, { once: true });
  } else {
    initialBoot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target || document);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    destroy(event.target || document);
  });

  window[RUNTIME_KEY] = Object.freeze({
    version: VERSION,
    boot: boot,
    destroy: destroy
  });
})(window, document);